import { ArrowDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { ChildLineageNode } from "./ChildLineageNode";
import { LineageNodeItem } from "./LineageNodeItem";
import { LineageNode } from "@/features/FileManagement/fileManagement.types";

export function RootLineageNode({
    node,
    isLast = false,
    level = 0,
    isOpen = false,
    setIsOpen,
}: {
    node: LineageNode;
    isLast?: boolean;
    level?: number;
    isOpen?: boolean;
    setIsOpen?: (isOpen: boolean) => void;
}) {
    return (
        <LineageNodeItem node={node} level={level} isLast={isLast}>
            {node.nodes && node.nodes.length > 0 && (
                <>
                    <span
                        className={clsx("ml-7 py-1", "flex items-center gap-3")}
                    >
                        <div className="h-0.5 w-3 rounded bg-slate-600" />

                        <button
                            onClick={() => setIsOpen?.(!isOpen)}
                            className="quiet -m-1 p-1"
                        >
                            {isOpen ? "See less" : "See more"}
                            <motion.span
                                animate={{ rotate: isOpen ? 180 : 0 }}
                                transition={{
                                    type: "spring",
                                    bounce: 0,
                                    duration: 0.4,
                                }}
                                className="flex"
                            >
                                <ArrowDownIcon className="size-4 text-gray-500" />
                            </motion.span>
                        </button>
                    </span>
                </>
            )}

            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0 }}
                        animate={{ height: "auto" }}
                        exit={{ height: 0 }}
                        transition={{
                            type: "spring",
                            bounce: 0,
                            duration: 0.4,
                        }}
                        className="overflow-hidden"
                    >
                        <ul
                            className={clsx(
                                "ml-6 pl-1",
                                "flex flex-col gap-6",
                                node.nodes?.length === 1 ? "pt-2" : "pt-5",
                            )}
                        >
                            {node.nodes?.map((childNode) => (
                                <ChildLineageNode
                                    key={childNode.id}
                                    node={childNode}
                                />
                            ))}
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </LineageNodeItem>
    );
}
